import { Container } from "../atoms/Container";
import { SunriseMark } from "../atoms/SunriseMark";

type SiteFooterProps = {
  mobile?: boolean;
};

const LINKS: Array<{ label: string; href: string }> = [
  { label: "Privacy", href: "/privacy-policy" },
  { label: "Terms", href: "/terms-of-service" },
  { label: "Support", href: "/support" },
];

export function SiteFooter({ mobile = false }: SiteFooterProps) {
  const pad = mobile ? 24 : 96;
  return (
    <footer
      style={{
        paddingTop: mobile ? 40 : 64,
        paddingBottom: mobile ? 40 : 64,
        borderTop: "0.5px solid var(--hairline)",
      }}
    >
      <Container pad={pad}>
        <div
          style={{
            display: mobile ? "flex" : "grid",
            flexDirection: "column",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: mobile ? 28 : 32,
            alignItems: "start",
            fontFamily: "var(--ui)",
            fontSize: 13,
            color: "var(--text-2)",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <SunriseMark size={24} />
            <div>© 2026 Speed AI.</div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: mobile ? "column" : "row",
              justifyContent: "center",
              gap: mobile ? 8 : 28,
            }}
          >
            {LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                style={{
                  color: "var(--text-2)",
                  textDecoration: "none",
                  borderBottom: "0.5px solid transparent",
                  transition: "border-color 160ms ease",
                }}
              >
                {link.label}
              </a>
            ))}
          </div>
          <div
            style={{
              textAlign: mobile ? "left" : "right",
              fontStyle: "italic",
              fontFamily: "var(--display)",
              fontSize: 14,
              color: "var(--text-2)",
            }}
          >
            Made for runners who haven&apos;t started yet.
          </div>
        </div>
      </Container>
    </footer>
  );
}
